import {
    MIN_TRIPLES,
    TYPE_0_PASS,
    TYPE_1_SINGLE,
    TYPE_2_PAIR,
    TYPE_3_TRIPLE,
    TYPE_4_BOMB,
    TYPE_5_KING_BOMB,
    TYPE_6_3_1,
    TYPE_7_3_2,
    TYPE_8_SERIAL_SINGLE,
    TYPE_9_SERIAL_PAIR,
    TYPE_10_SERIAL_TRIPLE,
    TYPE_11_SERIAL_3_1,
    TYPE_12_SERIAL_3_2,
    TYPE_13_4_2,
    TYPE_14_4_22,
    TYPE_15_WRONG,
    countCards,
} from './moveConstants';

function isContinuousSeq(move) {
    for (let i = 0; i < move.length - 1; i++) {
        if (move[i + 1] - move[i] !== 1) return false;
    }
    return true;
}

export function getMoveType(move) {
    const moveSize = move.length;
    const moveDict = countCards(move);

    if (moveSize === 0) return { type: TYPE_0_PASS };

    if (moveSize === 1) return { type: TYPE_1_SINGLE, rank: move[0] };

    if (moveSize === 2) {
        if (move[0] === move[1]) return { type: TYPE_2_PAIR, rank: move[0] };
        if ((move[0] === 20 && move[1] === 30) || (move[0] === 30 && move[1] === 20)) {
            return { type: TYPE_5_KING_BOMB };
        }
        return { type: TYPE_15_WRONG };
    }

    if (moveSize === 3) {
        if (Object.keys(moveDict).length === 1) return { type: TYPE_3_TRIPLE, rank: move[0] };
        return { type: TYPE_15_WRONG };
    }

    if (moveSize === 4) {
        if (Object.keys(moveDict).length === 1) return { type: TYPE_4_BOMB, rank: move[0] };
        if (Object.keys(moveDict).length === 2) {
            if (move[0] === move[1] && move[1] === move[2]) return { type: TYPE_6_3_1, rank: move[1] };
            if (move[1] === move[2] && move[2] === move[3]) return { type: TYPE_6_3_1, rank: move[1] };
            return { type: TYPE_15_WRONG };
        }
        return { type: TYPE_15_WRONG };
    }

    const sortedMove = [...move].sort((a, b) => a - b);
    if (isContinuousSeq(sortedMove)) {
        return { type: TYPE_8_SERIAL_SINGLE, rank: move[0], len: move.length };
    }

    if (moveSize === 5) {
        if (Object.keys(moveDict).length === 2) return { type: TYPE_7_3_2, rank: move[2] };
        return { type: TYPE_15_WRONG };
    }

    const countDict = {};
    Object.values(moveDict).forEach((n) => {
        countDict[n] = (countDict[n] || 0) + 1;
    });

    if (moveSize === 6) {
        const dictLen = Object.keys(moveDict).length;
        if (
            (dictLen === 2 || dictLen === 3) &&
            countDict[4] === 1 &&
            (countDict[2] === 1 || countDict[1] === 2)
        ) {
            return { type: TYPE_13_4_2, rank: move[2] };
        }
    }

    if (
        moveSize === 8 &&
        (((Object.keys(moveDict).length === 3 || Object.keys(moveDict).length === 2) &&
            countDict[4] === 1 &&
            countDict[2] === 2) ||
            countDict[4] === 2)
    ) {
        const rank = Math.max(...Object.keys(moveDict).map(Number).filter((c) => moveDict[c] === 4));
        return { type: TYPE_14_4_22, rank };
    }

    const mdkeys = Object.keys(moveDict)
        .map(Number)
        .sort((a, b) => a - b);
    if (Object.keys(moveDict).length === countDict[2] && isContinuousSeq(mdkeys)) {
        return { type: TYPE_9_SERIAL_PAIR, rank: mdkeys[0], len: mdkeys.length };
    }

    if (Object.keys(moveDict).length === countDict[3] && isContinuousSeq(mdkeys)) {
        return { type: TYPE_10_SERIAL_TRIPLE, rank: mdkeys[0], len: mdkeys.length };
    }

    if ((countDict[3] || 0) >= MIN_TRIPLES) {
        const serial3 = [];
        const single = [];
        const pair = [];

        Object.entries(moveDict).forEach(([k, v]) => {
            const key = Number(k);
            if (v === 3) serial3.push(key);
            else if (v === 1) single.push(key);
            else if (v === 2) pair.push(key);
            else return { type: TYPE_15_WRONG };
        });

        serial3.sort((a, b) => a - b);
        if (isContinuousSeq(serial3)) {
            if (serial3.length === single.length + pair.length * 2) {
                return { type: TYPE_11_SERIAL_3_1, rank: serial3[0], len: serial3.length };
            }
            if (serial3.length === pair.length && Object.keys(moveDict).length === serial3.length * 2) {
                return { type: TYPE_12_SERIAL_3_2, rank: serial3[0], len: serial3.length };
            }
        }

        if (serial3.length === 4) {
            if (isContinuousSeq(serial3.slice(1))) {
                return { type: TYPE_11_SERIAL_3_1, rank: serial3[1], len: serial3.length - 1 };
            }
            if (isContinuousSeq(serial3.slice(0, -1))) {
                return { type: TYPE_11_SERIAL_3_1, rank: serial3[0], len: serial3.length - 1 };
            }
        }
    }

    return { type: TYPE_15_WRONG };
}
